import { render } from "./UserBalanceAndAddress.vue?vue&type=template&id=007c540e&scoped=true"
import script from "./UserBalanceAndAddress.vue?vue&type=script&lang=js"
export * from "./UserBalanceAndAddress.vue?vue&type=script&lang=js"

import "@/Common/Styles/UserBalanceAndAddress.scss?vue&type=style&index=0&id=007c540e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007c540e"]])

export default __exports__